enum DocumentRole {
  PARTICIPANT = 'PARTICIPANT',
  REQUESTER = 'REQUESTER',
  HOST = 'HOST',
}

export default DocumentRole;
